import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-revert-file',
  templateUrl: './revert-file.component.html',
  styleUrls: ['./revert-file.component.css']
})
export class RevertFileComponent implements OnInit {
  uid: any;
  accountId: any;
  public patientForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  btndisabled = false;
  showInput = true;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private accountService: AccountService,
  private formbuilder: UntypedFormBuilder,
  private matDialog: MatDialogRef<any>) { }

  ngOnInit(): void {
    this.createForm();
    this.uid = this.data.uid;
    this.accountId = this.data.accountId;
  }
  createForm() {
    this.patientForm = this.formbuilder.group({
      customerIdFormat: ['AUTO'],
      otp: []
    });
  }
  generateOtp() {
    this.btndisabled = false;
    this.api_error = '';
    this.accountService.generateOtpForRevert(this.accountId, this.uid)
      .subscribe(res => {
        this.api_success = 'OTP Generated successfully';
          setTimeout(() => {
            this.showInput = false;
            this.api_success = ''
          }, 1000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
  dataRevert() {
    this.btndisabled = false;
    this.api_error = '';
    this.accountService.dataRevert(this.accountId, this.uid, this.patientForm.get('otp').value)
      .subscribe(res => {
        this.api_success = 'Data Reverted successfully';
        this.showInput = false;
        setTimeout(() => {
          this.matDialog.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.btndisabled = false;
        });
  }
}
